export const convert = (data: any) => ({
  ...data,
  status: data?.status?.value,
});
